<template>
  <el-dialog
    class="block-info  common-dialog"
    title="区块信息详情"
    :visible.sync="showDialog"
    top="5vh"
    @open="onShow"
  >
    <div class="block-detail">
      <common-bg-plate>
        <detail-table :title="title1" :table-col="tableCol1" :list="list1"></detail-table>
        <detail-table :title="title2" :table-col="tableCol2" :list="list2"></detail-table>
        <detail-section class="tx-detail-section" title="交易信息">
          <normal-table
            :table-data="list"
            :table-col="labelList"
            :paging="{ total: list.length }"
            :show-edit="showDetails"
            :show-pagination="false"
          ></normal-table>
        </detail-section>
      </common-bg-plate>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="makeSure">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import timeImg from '@/assets/images/tableIcon/time.png'
import hashImg from '@/assets/images/tableIcon/hash.png'
import frontHashImg from '@/assets/images/tableIcon/front-hash.png'
import readWriteHashImg from '@/assets/images/tableIcon/read-write-hash.png'
import heightImg from '@/assets/images/tableIcon/height.png'
import organizationImg from '@/assets/images/tableIcon/organization.png'
import merkelImg from '@/assets/images/tableIcon/merkel.png'
import dagFeaturesImg from '@/assets/images/tableIcon/dag-features.png'
import cdnNodeImg from '@/assets/images/tableIcon/cdn-node.png'

import { mapState, mapActions } from 'vuex'
export default {
  name: 'BlockInfo',
  components: {},
  props: {
    dialogVisible: Boolean,
    blockInfo: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      showDialog: false,
      event: {
        click: row => {
          return this.goTxDetailFn(row)
        }
      },
      title1: '区块基本信息',
      tableCol1: [
        { label: '区块Hash', icon: hashImg, value: 'blockHash' },
        { label: '区块高度', icon: heightImg, value: 'blockHeight' },
        { label: '前区块Hash', icon: frontHashImg, value: 'preBlockHash' },
        { label: '时间戳', icon: timeImg, value: 'createAt' }
      ],
      list1: {},
      title2: '其他信息',
      tableCol2: [
        { label: '读写集哈希', icon: readWriteHashImg, value: 'rwSetHash' },
        { label: '交易默克尔根', icon: merkelImg, value: 'txRootHash' },
        { label: 'DAG特征值', icon: dagFeaturesImg, value: 'dagHash' },
        { label: '出块组织', icon: organizationImg, value: 'OrgId' },
        { label: '出块节点', icon: cdnNodeImg, value: 'proposer_id' }
      ],
      list2: {},
      //交易信息
      showDetails: false,
      labelList: [
        { label: '交易ID', value: 'txId' },
        { label: '发起组织', value: 'orgId' },
        { label: '目标合约', value: 'contractName' },
        { label: '上链时间', value: 'createAt' },
        { label: '发起用户', value: 'sender' },
        { label: '交易状态', value: 'txStatusCode' }
      ],
      list: []
    }
  },
  computed: {
    hBlockInfo: function() {
      return (
        this.blockInfo || {
          header: {
            proposer: {}
          },
          txs: []
        }
      )
    }
  },
  watch: {
    dialogVisible: function(val) {
      this.showDialog = val
    },
    showDialog: function(val) {
      this.$emit('update:dialogVisible', val)
    }
  },
  methods: {
    onShow() {
      this.list1 = {
        blockHash: this.hBlockInfo.header.block_hash,
        blockHeight: this.hBlockInfo.header.block_height,
        preBlockHash: this.hBlockInfo.header.pre_block_hash,
        createAt: this.formatTime(this.hBlockInfo.header.block_timestamp)
      }
      this.list2 = {
        rwSetHash: this.hBlockInfo.header.rw_set_root,
        txRootHash: this.hBlockInfo.header.tx_root,
        dagHash: this.hBlockInfo.header.dag_hash,
        OrgId: this.hBlockInfo.header.proposer.org_id,
        proposer_id: this.$constants.EMPTY
      }
      this.list = []
      for (let i = 0; i < this.hBlockInfo.txs.length; i++) {
        let item = this.hBlockInfo.txs[i]
        this.list.push({
          txId: item.payload.tx_id,
          orgId: item.sender.signer.org_id,
          contractName: item.payload.contract_name,
          createAt: this.formatTime(item.payload.timestamp),
          sender: this.$constants.EMPTY,
          txStatusCode: item.result.contract_result.result
        })
      }
    },
    makeSure() {
      this.showDialog = false
    },
    formatTime(time) {
      return this.$utils.dateFormat('YYYY-mm-dd HH:MM', time * 1000)
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';

@include theme('block-info', (), ());
.block-info {
  @include adaptation(
    (
      --block-info-width: 1260px,
      --block-info-tx-list-item-height: 64px,
      --block-info-content-unavailable-height: 233px,
      --block-info-tx-detail-unavailable-height: 614px,
      --content-margin-bottom: 16px,
      --data-list-table-unavailable-height: 16px,
      --data-list-table-header-height: 40px,
      --block-info-tx-detail-height: 168px
    )
  );
  --block-info-content-min-height: calc(93vh - var(--block-info-content-unavailable-height));
  --block-info-tx-detail-min-height: max(var(--block-info-tx-detail-height), calc(
    var(--block-info-content-min-height) - var(--block-info-tx-detail-unavailable-height))
  );

  /deep/ .el-dialog {
    width: var(--block-info-width);
  }

  .common-bg-plate {
    min-height: var(--block-info-content-min-height);
    margin-bottom: var(--content-margin-bottom);
    .tx-detail-section {
      padding-bottom: 0;
      /deep/ .content {
        padding-bottom: 0;
      }
    }
    .normal-table-wrap {
      --data-list-height: var(--block-info-tx-detail-min-height);
      min-height: var(--data-list-height);
      /deep/ {
        .el-empty {
          height: 100%;
          min-height: var(--data-list-height);
        }

        .normal-table {
          min-height: var(--data-list-height);
          padding-bottom: 0;
          .el-table {
            height: calc(var(--data-list-height) - var(--data-list-table-unavailable-height));
            .el-table__body {
              tr {
                height: var(--block-info-tx-list-item-height);
              }
            }

            .el-table__body-wrapper {
              height: calc(
                var(--data-list-height) - var(--data-list-table-unavailable-height) -
                  var(--data-list-table-header-height)
              );
              overflow-y: auto;
            }
          }
        }
      }
    }
  }
}
</style>
